<template>
  <div id="reset" class="c-forgot c-page">
    <div class="c-page__inner l-columns-container l-columns-container--outmost">
      <div class="l-tablet-column--4">
        <h1 class="f-headline"><strong>Nulstil</strong> dit kodeord</h1>
      </div>

      <div class="l-tablet-column--6">
        <div v-if="response" class="c-input-valid">
          <p class="c-input-valid__text">{{ response }}</p>
        </div>
        <div v-if="errorMessage" class="c-error">
          <p class="c-error__text" v-html="errorMessage"></p>
        </div>

        <form class="c-form general-form">
          <input
            class="c-form__element"
            type="password"
            name="password"
            v-model="input.password"
            placeholder="Password"
          />
          <input
            class="c-form__element"
            type="password"
            name="password"
            v-model="input.passwordControl"
            placeholder="Gentag password"
          />

          <label class="c-form__submit" @click.prevent="resetPassword()">
            <SpinnerButton
              ref="request"
              class="c-form__submit"
              cta="Gem password"
              action="Gemmer"
            />

            <input type="submit" value="Login" />
          </label>

          <!-- <SpinnerButton
            ref="request"
            cta="Nulstil kodeord"
            action="Nulstiller"
            class="c-form__submit"
            @clickaction="requestPassword"
          />-->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerButton from "@/components/SpinnerButton.vue";
export default {
  name: "Reset",
  components: {
    // ArrowLink,
    SpinnerButton,
  },
  data() {
    console.log();
    return {
      redirect: this.$route.query.redirect || null,
      query: this.$route.query,
      email: this.$route.params.email,
      uid: this.$route.params.uid,
      resetToken: this.$route.params.resetToken,
      errorMessage: "",
      response: "",
      input: {
        password: "",
        passwordControl: "",
      },
    };
  },
  methods: {
    formalValidation() {
      if (!this.input.password) {
        return {
          valid: false,
          error: "Du skal skrive dit nye password",
        };
      }
      if (!this.input.passwordControl) {
        return {
          valid: false,
          error: "Du skal gentage dit nye password",
        };
      }
      if (this.input.passwordControl != this.input.password) {
        return {
          valid: false,
          error: "De to passwords er ikke ens",
        };
      }
      return { valid: true };
    },
    resetPassword() {
      const validation = this.formalValidation();

      if (!validation.valid) {
        this.handleError(validation);
        return;
      }

      //console.log(this.$route.params);

      this.$userService
        .reset(this.input.password, this.uid, this.resetToken)
        .then((data) => {
          //if (data)
          console.log(data);
          console.log(this.$userService.user);
          if (!this.$userService.user.customer_id) {
            this.$userService.registerCustomer().then((subscription) => {
              this.$router.push(
                {
                  name: "creditcard",
                  query: this.query || { redirect: "landing" },
                },
                () => {
                  return;
                }
              );
            });
          } else if (this.redirect) {
            return this.$router.push({
              name: this.redirect,
              query: this.query,
            });
          } else {
            this.$router.push({ name: "user" }, () => {
              return;
            });
          }
        })
        .catch((error) => {
          // HAndle error
          console.log("catch");
          console.dir(error);
          if (error.status && error.status === 400) {
            this.handleError({
              valid: false,
              error: `Dette link er blevet brugt før. <a href="/glemt">Prøv igen</a>`,
            });
          } else {
            this.handleError({
              valid: false,
              error: "Der er sket en fejl. Prøv igen senere.",
            });
          }
        });
    },
    handleError(error) {
      console.log(error);
      this.$refs.request.reset();
      this.errorMessage = error.error;
    },
  },
};
</script>

<style scoped></style>
